import { useEffect, useState } from "react";
import usePagination from "../../usePagination";
import { fetchMembersOfGroup } from "../../../service/UserService/groupService";
import { message } from "antd";

export const useGroupHistoryUser = (groupId) => {
    const [groupUserData, setGroupUserData] = useState([]);
    const [Userloading, setUserLoading] = useState(false);
  const {
    currentPage,
    pageSize,
    setTotal,
    paginationConfig,
    handlePageChange,
    setCurrentPage,
  } = usePagination(0, 10);


      const getGroupData = async () => {
    setUserLoading(true);

    const params = {
      page: currentPage,
      size: pageSize,
    };

    const response = await fetchMembersOfGroup(groupId, params);

    if (response.success) {
      setGroupUserData(response?.data?.content || []);
      setTotal(response?.data?.totalElements || 0);
    } else {
      message.error(response.message);
    }

    setUserLoading(false);
  };

    useEffect(() => {
    getGroupData();
  }, [currentPage, pageSize]);


  return {
    groupUserData,
    Userloading,
    paginationConfig,
    handlePageChange,
    getGroupData,
  }
}